import { Injectable } from '@angular/core';
import { CanActivateChild } from '@angular/router';

import { AuthGuard } from '../../../core/services/auth/auth-guard.service';
import { UsuarioPerfil, usuarioPerfilAdministrador } from '../../usuario/usuario-perfil';


/** Acessos permitidos a consulta dos Status dos Pedidos */
export const acessosPedidoResultadoLiquido: UsuarioPerfil[] = [usuarioPerfilAdministrador];

@Injectable()
export class CanActivatePedidoResultadoLiquido implements CanActivateChild {

    constructor(private authGuard: AuthGuard) { }

    canActivateChild(): boolean {
        return this.authGuard.canActivateAcesso(acessosPedidoResultadoLiquido);
    }
}
